import { render, staticRenderFns } from "./BiometricsSummary.vue?vue&type=template&id=890f6124"
import script from "./BiometricsSummary.vue?vue&type=script&lang=js"
export * from "./BiometricsSummary.vue?vue&type=script&lang=js"
import style0 from "./BiometricsSummary.vue?vue&type=style&index=0&id=890f6124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports